<template lang="pug">
#slick-top.slider.slider-nav(style="display: none;")
  router-link.top-game-thumb(
    v-if="whiteLabel"
    to="/tournament2"
    )
    img.img-fluid(src="/images/main-top/tournament2.jpg")
  router-link.top-game-thumb(
    v-else
    to="/tournament2"
    target="_blank"
    onclick="window.open(this.href,'tourplus','height=700,width=1440,status=no,toolbar=no,menubar=no,location=no');return false;"
    )
    img.img-fluid(src="/images/main-top/tournament2.jpg")

  a.top-game-thumb(href="javascript:void(0);" @click="setGame")
    img.img-fluid(src="images/main-top/v-games1.jpg")
  router-link.top-game-thumb(
    v-if="!whiteLabel && ['MYR', 'USD', 'THB', 'MMK', 'CNY', 'IDR', 'SGD'].includes(currency_code)"
    to="/slots12",
    target="_blank",
    onclick="window.open(this.href,'slots12','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    )
    img.img-fluid(src="images/main-top/live22.jpg")

  router-link.top-game-thumb(
    v-if="whiteLabel"
    to="/highlight"
    )
    img.img-fluid(src="/images/main-top/highlights.jpg")
  router-link.top-game-thumb(
    v-else
    to="/highlight"
    target="_blank"
    onclick="window.open(this.href,'highlight','top=10,height=700,width=1366,status=no,toolbar=no,menubar=no,location=no');return false;"
    )
    img.img-fluid(src="/images/main-top/highlights.jpg")
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {},
  data() {
    return {
      options: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        variableWidth: false,
        infinite: false,
        focusOnSelect: false,
        centerMode: false,
        centerPadding: "0",
      },
    };
  },
  computed: {
    newFeatures() {
      return config.newFeatures;
    },
    whiteLabel() {
      return config.whiteLabel;
    },
    currency_code() {
      return this.$store.getters.currencyCode;
    },
  },
  watch: {},
  destroyed() {
    this.slickDestroy();
  },
  mounted() {
    this.slickInit();
  },
  methods: {
    setGame() {
      if (EventBus.setGame) {
        EventBus.setGame();
      }
    },
    onInit() {},
    onDestroy() {},
    setSlide(e) {
      const $slick = $(this.$el);
      if (e != null) {
        $slick.slick("slickGoTo", e, true);
      }
    },
    onAfterChange(e, s, c) {},
    slickInit() {
      const $slick = $(this.$el);
      $slick.on("afterChange", this.onAfterChange);
      $slick.on("destroy", this.onDestroy);
      $slick.on("init", this.onInit);
      // if (this.whiteLabel) {
      //   this.options.slidesToShow = 2;
      // }
      $slick.slick(this.options);
      $slick.slick("slickGoTo", 0, true);
      $("#slick-top").show();
    },
    slickDestroy() {
      const $slick = $(this.$el);
      $slick.off("afterChange", this.onAfterChange);
      $slick.off("destroy", this.onDestroy);
      $slick.off("init", this.onInit);
      $(this.$el).slick("unslick");
    },
  },
};
</script>

<style></style>
